import React from 'react';
import { Spinner } from '../Spinner';

var A4_Spinner = function A4_Spinner(props) {
  return /*#__PURE__*/React.createElement(Spinner, props);
};

export { A4_Spinner };